export const FETCH_SCREENER_REQUEST = 'FETCH_SCREENER_REQUEST';
export const FETCH_SCREENER_SUCCESS = 'FETCH_SCREENER_SUCCESS';
export const FETCH_SCREENER_FAILURE = 'FETCH_SCREENER_FAILURE';

export const FETCH_DOCUMENTS_REQUEST = 'FETCH_DOCUMENTS_REQUEST';
export const FETCH_DOCUMENTS_SUCCESS = 'FETCH_DOCUMENTS_SUCCESS';
export const FETCH_DOCUMENTS_FAILURE = 'FETCH_DOCUMENTS_FAILURE';

export const FETCH_DISCLOSURES_REQUEST = 'FETCH_DISCLOSURES_REQUEST';
export const FETCH_DISCLOSURES_SUCCESS = 'FETCH_DISCLOSURES_SUCCESS';
export const FETCH_DISCLOSURES_FAILURE = 'FETCH_DISCLOSURES_FAILURE';

export const FETCH_NETGROSSDISCLOSURES_REQUEST = 'FETCH_NETGROSSDISCLOSURES_REQUEST';
export const FETCH_NETGROSSDISCLOSURES_SUCCESS = 'FETCH_NETGROSSDISCLOSURES_SUCCESS';
export const FETCH_NETGROSSDISCLOSURES_FAILURE = 'FETCH_NETGROSSDISCLOSURES_FAILURE';

export const FETCH_HYPO_CHART_REQUEST = 'FETCH_HYPO_CHART_REQUEST';
export const FETCH_HYPO_CHART_SUCCESS = 'FETCH_HYPO_CHART_SUCCESS';
export const FETCH_HYPO_CHART_FAILURE = 'FETCH_HYPO_CHART_FAILURE';

export const UPDATE_MSTAR_FILTER = 'UPDATE_MSTAR_FILTER';
export const UPDATE_RANGE_FILTER = 'UPDATE_RANGE_FILTER';
export const UPDATE_ASSET_FILTER = 'UPDATE_ASSET_FILTER';
export const UPDATE_FUNDTYPE_FILTER = 'UPDATE_FUNDTYPE_FILTER';
export const UPDATE_PRODUCT_FILTER = 'UPDATE_PRODUCT_FILTER';
export const UPDATE_STYLE_BOX_FILTER = 'UPDATE_STYLE_BOX_FILTER';
export const UPDATE_PRESET_CATEGORY = 'UPDATE_PRESET_CATEGORY';
export const UPDATE_PLAN_NUMBER = 'UPDATE_PLAN_NUMBER';
export const FILTER_PLAN_HOLDINGS = 'FILTER_PLAN_HOLDINGS';
export const UPDATE_PARTICIPANT_HOLDINGS = 'UPDATE_PARTICIPANT_HOLDINGS';
export const UPDATE_SEARCHED_HOLDINGS = 'UPDATE_SEARCHED_HOLDINGS';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SHOW_ONLY_MY_HOLDINGS = 'SHOW_ONLY_MY_HOLDINGS';
export const SHOW_ONLY_TIAA = 'SHOW_ONLY_TIAA';
export const SHOW_NULL_DATA = 'SHOW_NULL_DATA';
export const RESET_FILTERS = 'RESET_FILTERS';
export const RESET_HOLDINGS_CONTEXT = 'RESET_HOLDINGS_CONTEXT';
export const REDUCE_ARGS = 'REDUCE_ARGS';
export const UPDATE_SORT = 'UPDATE_SORT';
export const UPDATE_RESULT_LIMIT = 'UPDATE_RESULT_LIMIT';
export const FETCH_PLAN_FAILURE = 'FETCH_PLAN_FAILURE';
export const FETCH_PLAN_REQUEST = 'FETCH_PLAN_REQUEST';
export const FETCH_PLAN_SUCCESS = 'FETCH_PLAN_SUCCESS';
export const FETCH_FOOTNOTESLABEL_SUCCESS = 'FETCH_FOOTNOTESLABEL_SUCCESS';
export const FETCH_FOOTNOTESLABEL_FAILURE = 'FETCH_FOOTNOTESLABEL_FAILURE';
export const REDUCE_ARGS_DISTRIBUTIONS = 'REDUCE_ARGS_DISTRIBUTIONS';
export const UPDATE_DISTRIBUTIONS_PERIOD = 'UPDATE_DISTRIBUTIONS_PERIOD';

export const FETCH_DISCLOSURES_BULK_REQUEST = 'FETCH_DISCLOSURES_BULK_REQUEST';
export const FETCH_DISCLOSURES_BULK_SUCCESS = 'FETCH_DISCLOSURES_BULK_SUCCESS';
export const FETCH_DISCLOSURES_BULK_FAILURE = 'FETCH_DISCLOSURES_BULK_FAILURE';
